import { request } from "../utils/request.js"

export const commodity_addNew = (pojo, args) => request({
    url: 'commodity/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_update = (pojo, args) => request({
    url: 'commodity/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_findByPageForManage = (pojo, args) => request({
    url: 'commodity/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodity_findByPageForSelect = (pojo, args) => request({
    url: 'commodity/findByPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const commodity_supplyQuantity = (pojo, args) => request({
    url: 'commodity/supplyQuantity',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_changeFrozenStatus = (id, args) => request({
    url: 'commodity/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const commodity_deleteById = (id, args) => request({
    url: 'commodity/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commodity_findById = (id, args) => request({
    url: 'commodity/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commodity.js